
import React from "react";
import {StaticFieldDisplayProps} from "../staticFieldUtils.ts";
import {
    FormError,
    FormLabel,
    getInputClassNames,
    getInputWrapperClass,
    getWholeDivWrapperClass
} from "../../sharedStyles.tsx";



const StaticSpacerRenderer: React.FC<StaticFieldDisplayProps> = ({ component , value, controller}) => {
    const {fieldState} = controller;
    if (value == 1) {
        return (
            <div className={getWholeDivWrapperClass(component) + " invisible"}>
                <FormLabel component={component}></FormLabel>
                <div className={getInputWrapperClass(component)}>
                                        <span className={getInputClassNames(component, fieldState)}>
                                            {value}
                                        </span>
                </div>
                <FormError fieldState={fieldState} component={component} />
            </div>
        )
    }
    return (
        <div className={`h-${value} mb-2.5 invisible`}>
        </div>
    );
};

export const StaticSpacer = React.memo(StaticSpacerRenderer);